type BadgeProps = {
  variant: string
  children?: string | JSX.Element
}

const Badge = ({
  variant = 'success',
  children,
} : BadgeProps) => {
  return <span className={`${variant}
    px-1.5
    py-0.5
    rounded
    w-fit
  `}>{children}
  </span>
}

export default Badge